// extracted by mini-css-extract-plugin
export default {"container":"AttachmentCardV2__container___u3UW8"};